import {
  faBell,
  faThumbsDown,
  faThumbsUp,
} from "@fortawesome/pro-regular-svg-icons";
import { Button } from "@novaescola/eva-react-v2/lib/Button";
import { Icon } from "@novaescola/eva-react-v2/lib/Icon";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import { meuPerfilApi } from "../../api/meu-perfil/meu-perfil.api";

export default function ThemeFund2Subscribe({
  loggedIn,
  setShowSubscribeThemeFund2,
}) {
  const apiUrl = process.env.GATSBY_ACCOUNT_API_BASE_URL;
  const authRedirect = apiUrl + "/auth/signin";

  const [showAlert, setShowAlert] = useState(false);
  const [showBlock, setShowBlock] = useState(false);

  useEffect(() => {
    if (showAlert) {
      setTimeout(() => {
        setShowAlert(false);
        setShowSubscribeThemeFund2(false);
      }, 10000);
    }
  }, [showAlert]);

  useEffect(() => {
    let subThemeTech = Cookies.get("ane_subscribe_fund2_theme");
    if (subThemeTech !== null && subThemeTech !== undefined) {
      handleSubscribe(subThemeTech === "SIM", subThemeTech);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "block_visualization",
        label: `JORNALISMO: interesse no tema - anos finais - bloco visualizado`,
      });
      setShowBlock(true);
    }
  }, []);

  async function handleSubscribe(subscribeTheme, subThemeTech) {
    const bearer = Cookies.get("Bearer");
    if (subThemeTech !== null) {
      const subscribed = await meuPerfilApi.getInterestInTheme(bearer, 3);
      if (subscribed.data !== "") {
        setShowBlock(false);
        return;
      }
    }
    const expires = new Date();
    expires.setUTCFullYear(expires.getUTCFullYear() + 1);
    Cookies.set("ane_subscribe_fund2_theme", subscribeTheme ? "SIM" : "NÃO", {
      domain: ".novaescola.org.br",
      expires,
    });

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "cta_click",
      label: `JORNALISMO: interesse no tema - anos finais - ${
        subscribeTheme ? "SIM" : "NÃO"
      }`,
    });

    if (loggedIn) {
      let payload = {
        temaId: 3,
        subscribeToTheme: subscribeTheme,
      };
      await meuPerfilApi.saveInterestInTheme(bearer, payload);
    } else {
      Cookies.set("ane_redirect", window.location.href, {
        domain: ".novaescola.org.br",
      });
      window.location.href = authRedirect;
    }
    setShowAlert(true);
  }

  return (
    <>
      {showAlert ? (
        <div role="alert" className="eva-alert sucesso">
          <div className="alerta-info">
            <i className="fa-regular fa-circle-check alerta-icon"></i>
            <p>Informação salva com sucesso!</p>
          </div>
          <button
            aria-label="Fechar alerta"
            className="btn-close-alert"
            onClick={() => {
              setShowAlert(false);
            }}
          >
            <i className="fa-regular fa-xmark"></i>
          </button>
        </div>
      ) : (
        showBlock && (
          <div className="theme-subscribe-container">
            <Typography
              variant="title"
              size={6}
              className="theme-subscribe-title"
              style={{ marginTop: "8px" }}
            >
              <Icon icon={faBell} style={{ marginRight: "8px" }} />
              Tem interesse no tema "Neurociência, adolescências e engajamento
              nos Anos Finais"?
            </Typography>
            <Typography
              variant="subtitle"
              size={4}
              style={{ marginTop: "8px" }}
            >
              Inscreva-se neste tema para receber novidades pelo site e por
              email.
            </Typography>
            <div className="theme-subscribe-btns">
              <Button
                color="black"
                size="small"
                className="theme-subscribe-btn"
                onClick={() => handleSubscribe(true, null)}
              >
                <Icon icon={faThumbsUp} />
                <Typography variant="body" size={3}>
                  SIM
                </Typography>
              </Button>
              <Button
                color="white"
                size="small"
                style={{ borderColor: "#000", marginLeft: "8px" }}
                className="theme-subscribe-btn"
                onClick={() => handleSubscribe(false, null)}
              >
                <Icon icon={faThumbsDown} />
                <Typography variant="body" size={3}>
                  NÃO
                </Typography>
              </Button>
            </div>
          </div>
        )
      )}
    </>
  );
}
